import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import wishReducer from './wishlistSlice';
import loadingReducer from './loadingSlice'; 
import sliderReducer from './sliderSlice';
import navigationReducer from './navigationSlice';
import productReducer from './productSlice';
import cartWishReducer from './cartWishSlice';
import compareReducer from './compareSlice'
import reviewReducer from './reviewSlice'
import qandaReducer from './qandaSlice'
import todayDealsReducer  from './todayDealsSlice'



const store = configureStore({
  reducer: {
    cart: cartReducer,
    loading: loadingReducer,
    wishlist: wishReducer,
    slider: sliderReducer,
    navigation: navigationReducer,
    products: productReducer,
    cartWish:cartWishReducer,
    compare:compareReducer,
    reviews: reviewReducer,
    questions: qandaReducer,
    todayDeals: todayDealsReducer,

  },
});

export default store;

